import React from "react";
import QmeterSection from "./header/QmeterSection";

const ErrorPage = () => {
  return (
    <div className="container">
      <QmeterSection
        height={"19.2%"}
        properties={{ page_header: [53, 64, 80] }}
      />
      <div className="error_page_content_wrapper">
        <div className="error_page_content">
          <div className="error_page_content_smile">
            <span className="qs-icon-s5"></span>
          </div>
          <p className="error_page_content_text">we couldn't load this page</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
